<canvas #canvas></canvas>
<br>
<div class="btn-group">
    <button class="btn btn-danger btn-sm" type="button" (click)=clearCanvas()>Clear</button>
</div>